<script setup lang="ts">
// Result card. Matches prototype's .res-card / overlay block — slides up
// from the bottom, anchored at viewport bottom, with subtle border colour
// switching between win/lose.
import type { SpinResult } from '../lib/api';

defineProps<{ result: SpinResult }>();
defineEmits<{ (e: 'close'): void }>();
</script>

<template>
  <div class="overlay show" @click.self="$emit('close')">
    <div class="res-card" :class="result.won ? 'win' : 'lose'">
      <template v-if="result.won && result.prize">
        <div class="res-icon">🎉</div>
        <img v-if="result.prize.image_url" :src="result.prize.image_url" alt="prize" class="res-pimg" />
        <div v-else class="res-emoji">{{ result.prize.emoji }}</div>
        <div class="res-title">YOU WON!</div>
        <div class="res-msg">You won <strong>{{ result.prize.name }}</strong>. Please collect your prize from the staff.</div>
        <button class="btn btn-gold" @click="$emit('close')">OK</button>
      </template>
      <template v-else>
        <div class="res-icon">🍀</div>
        <div class="res-title">BETTER LUCK NEXT TIME</div>
        <div class="res-msg">No win this time — give it another go!</div>
        <button class="btn btn-gold" @click="$emit('close')">SPIN AGAIN</button>
      </template>
    </div>
  </div>
</template>

<style scoped>
.overlay {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 200;
  padding: 0 12px 12px;
  pointer-events: all;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
}
.res-card {
  background: var(--dark2);
  border-radius: 20px 20px 16px 16px;
  padding: 24px 22px 20px;
  text-align: center;
  width: 100%;
  max-width: 460px;
  box-shadow: 0 -4px 32px rgba(0, 0, 0, 0.7);
  border: 2px solid transparent;
  border-top: 3px solid var(--or);
  animation: slideUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.res-card.win {
  border-color: var(--or);
}
.res-card.lose {
  border-color: #3a3a3c;
}
@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.res-icon {
  font-size: 44px;
  margin-bottom: 8px;
}
.res-pimg {
  width: 80px;
  height: 80px;
  object-fit: contain;
  margin: 0 auto 14px;
  display: block;
}
.res-emoji {
  font-size: 80px;
  line-height: 1;
  margin-bottom: 14px;
}
.res-title {
  font-size: 22px;
  font-weight: 900;
  margin-bottom: 6px;
  letter-spacing: 2px;
}
.res-card.win .res-title {
  color: var(--or);
}
.res-card.lose .res-title {
  color: var(--grey);
}
.res-msg {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.65);
  margin-bottom: 16px;
  line-height: 1.45;
}
.res-msg strong {
  color: var(--white);
}
.btn {
  width: 100%;
  padding: 14px;
  font-size: 16px;
}
</style>
